import { Link } from 'react-router-dom'
import './Footer.css'

function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-left">
          <div className="footer-logo">
            <div className="logo-icon">镜</div>
            TradeMirror
          </div>
          <p className="footer-copy">© 2026 Hilo Studio. 保留所有权利。</p>
        </div>
        <ul className="footer-links">
          <li><Link to="/">首页</Link></li>
          <li><Link to="/privacy">隐私协议</Link></li>
          <li><Link to="/terms">用户协议</Link></li>
          <li><a href="mailto:support@taroveil.com">联系我们</a></li>
        </ul>
      </div>
    </footer>
  )
}

export default Footer
